import type { ColorKey, MarginProperties } from '@iheartjane/reefer';
import {
  BlissfulIcon,
  LightningIcon,
  NotHighIcon,
  PainFreeIcon,
  PencilIcon,
  PizzaIcon,
  RelaxedIcon,
  SleepIcon,
  Typography,
} from '@iheartjane/reefer';
import capitalize from 'lodash-es/capitalize';

import { Feeling } from '@jane/search/types';

import { Tile } from '../Tile';

const feelingProps: Record<
  Feeling,
  {
    color: ColorKey;
    Icon: () => JSX.Element;
  }
> = {
  [Feeling.Blissful]: { Icon: () => <BlissfulIcon />, color: 'tangerine-dark' },
  [Feeling.Creative]: { Icon: () => <PencilIcon />, color: 'tangerine-dark' },
  [Feeling.Energetic]: {
    Icon: () => <LightningIcon />,
    color: 'ember-dark',
  },
  [Feeling.Hungry]: { Icon: () => <PizzaIcon />, color: 'ember-dark' },
  [Feeling.NotHigh]: { Icon: () => <NotHighIcon />, color: 'grays-mid' },
  [Feeling.PainFree]: { Icon: () => <PainFreeIcon />, color: 'grays-mid' },
  [Feeling.Relaxed]: { Icon: () => <RelaxedIcon />, color: 'tangerine-dark' },
  [Feeling.Sleepy]: { Icon: () => <SleepIcon />, color: 'purple-dark' },
};

const getFeelingProps = (feeling: Feeling) => {
  return feelingProps[feeling];
};

export interface FeelingTileProps extends MarginProperties {
  feeling: Feeling;
}

export const FeelingTile = ({ feeling, ...rest }: FeelingTileProps) => {
  const { Icon, color } = getFeelingProps(feeling);
  return (
    <Tile
      background="grays-ultralight"
      borderRadius="sm"
      p={24}
      width="33%"
      {...rest}
    >
      <Icon />
      <Typography color={color} variant="body-bold" mt={8}>
        {capitalize(feeling)}
      </Typography>
    </Tile>
  );
};
